
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/artworks",
      function () {
        return require("private-next-pages/user/artworks.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user/artworks"])
      });
    }
  